import { isArray, isEmpty } from 'lodash';

const DEV_LOCAL_STRINGS_KEY = 'AmazonAuthorLocalStringsEnabled';

export const isLocalStringsEnabled = domain => (
  domain === 'test' && localStorage.getItem(DEV_LOCAL_STRINGS_KEY)
);

const getAssetNames = () => {
  // Get all the json file in /configuration/i18n/strings
  const jsonFiles = require.context('../../configuration/i18n/strings',
    false, /\.json$/);
  // Get filename only.
  // Example: './foo.json' becomes 'foo'
  return jsonFiles.keys().map(fileName => fileName.split('/').pop().split('.').shift());
};

const assetNamesMap = {};

const loadCaseSensitiveAssetNames = () => {
  if (isEmpty(assetNamesMap)) {
    const files = getAssetNames();
    files.forEach((file) => {
      assetNamesMap[file.toLowerCase()] = file;
    });
  }
};

export const getLocalStrings = (assetName) => {
  loadCaseSensitiveAssetNames();
  const strings = {};
  if (assetNamesMap[assetName]) {
    // eslint-disable-next-line import/no-dynamic-require
    const jsonFile = require(`../../configuration/i18n/strings/${assetNamesMap[assetName]}.json`);
    const stringsArray = jsonFile.strings;
    const key = 'id';
    const value = 'en_DEV';
    if (stringsArray && isArray(stringsArray)) {
      stringsArray.forEach((stringObject) => {
        if (stringObject[key] && stringObject[value]) {
          strings[stringObject[key]] = stringObject[value];
        }
      });
    }
  }
  return strings;
};
